// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mk_k","input":"styles_input__3QTMZ"};